import React from 'react';
import { useLocation } from 'wouter';
import { BookOpen, Users } from 'lucide-react';

const LandingPage: React.FC = () => {
    const [, setLocation] = useLocation();
    const [isNavigating, setIsNavigating] = React.useState(false);
  
    const handleNavigation = (path: string) => {
      setIsNavigating(true);
      setLocation(path);
    };

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        
        {/* Logo/Header */}
        <div className="text-center mb-12">
          <img 
            src="/logo_xl.png" 
            alt="Vedyx Learning" 
            className="h-20 sm:h-24 w-auto mx-auto mb-6"
          />
        </div>

        {/* Stacked Cards */}
        <div className="space-y-4">
          
          {/* Student Path */}
          <button
            onClick={() => handleNavigation('/child-login')}
            disabled={isNavigating}
            className="w-full group bg-white border-2 border-gray-200 rounded-2xl p-6 
                       hover:border-deep-ocean-blue hover:shadow-lg
                       transition-all duration-200
                       text-left focus:outline-none focus:ring-2 focus:ring-deep-ocean-blue focus:ring-offset-2
                       disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0
                            group-hover:bg-blue-100 transition-colors">
                <BookOpen className="w-6 h-6 text-deep-ocean-blue" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-header-primary mb-2">
                    Let's learn!
                </h2>
                <p className="text-body-text text-sm leading-relaxed">
                  Log in to continue your learning journey
                </p>
              </div>
            </div>
          </button>

          {/* Parent Path */}
          <button
            onClick={() => handleNavigation('/parent-login')}
            disabled={isNavigating}
            className="w-full group bg-white border-2 border-gray-200 rounded-2xl p-6 
                       hover:border-sage-green hover:shadow-lg
                       transition-all duration-200
                       text-left focus:outline-none focus:ring-2 focus:ring-sage-green focus:ring-offset-2
                       disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-green-50 flex items-center justify-center flex-shrink-0
                            group-hover:bg-green-100 transition-colors">
                <Users className="w-6 h-6 text-sage-green" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-header-primary mb-2">
                  I'm a parent or teacher
                </h2>
                <p className="text-body-text text-sm leading-relaxed">
                  Manage accounts and view progress
                </p>
              </div>
            </div>
          </button>
        </div>

        {/* Subtle footer for new signups */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500">
            Parents: First time here?{' '}
            <button
              onClick={() => handleNavigation('/parent-signup')}
              disabled={isNavigating}
              className="text-deep-ocean-blue hover:underline font-medium disabled:opacity-50 disabled:no-underline"
            >
              Create an account
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;